export const ACTION_TYPES = {
  MATCH_POST: 'match/MATCH',
  MATCH_SUCCESS: 'match/MATCH_SUCCESS',
  MATCH_ERROR: 'match/MATCH_ERROR',
  MATCH_CLEANUP: 'match/MATCH_CLEANUP',
  // setting fields
  SET_BUYER_REDUCTION: 'match/SET_BUYER_REDUCTION',
  CLEAR_BUYER_REDUCTION: 'match/CLEAR_BUYER_REDUCTION',
}
